var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* tslint:disable: no-console */
import { meshTilesetFlyover1 } from "./test/cases/meshTilesetFlyover1";
import { meshTilesetFlyover2 } from "./test/cases/meshTilesetFlyover2";
import { meshTilesetFlyover3 } from "./test/cases/meshTilesetFlyover3";
import { meshTilesetFlyover4 } from "./test/cases/meshTilesetFlyover4";
import { movingGradientColor1 } from "./test/cases/movingGradientColor1";
import { movingIntensityColor1 } from "./test/cases/movingIntensityColor1";
import { tilesetViewer } from "./test/cases/utils/tilesetViewer";
import { movingClassificationColor1 } from "./test/cases/movingClassificationColor1";
import { instancedMeshTilesetFlyover1 } from "./test/cases/instancedMeshTilesetFlyover1";
import { cesiumImageryFlyover1 } from "./test/cases/cesiumImageryFlyover1";
import { bingImageryFlyover1 } from "./test/cases/bingImageryFlyover1";
import { bingImageryFlyover2 } from "./test/cases/bingImageryFlyover2";
import { bingImageryFlyover3 } from "./test/cases/bingImageryFlyover3";
import { osmImageryFlyover1 } from "./test/cases/osmImageryFlyover1";
import { layeredImageryFlyover1 } from "./test/cases/layeredImageryFlyover1";
import { layeredImageryFlyover2 } from "./test/cases/layeredImageryFlyover2";
import { panoramaView1 } from "./test/cases/panoramaView1";
import { panoramaView2 } from "./test/cases/panoramaView2";
import { panoramaView3 } from "./test/cases/panoramaView3";
import { panoramaView4 } from "./test/cases/panoramaView4";
import { primitiveBox1 } from "./test/cases/primitiveBox1";
import { primitiveBox2 } from "./test/cases/primitiveBox2";
import { primitiveBox3 } from "./test/cases/primitiveBox3";
import { primitiveBox4 } from "./test/cases/primitiveBox4";
import { primitiveBox5 } from "./test/cases/primitiveBox5";
import { primitiveSphere1 } from "./test/cases/primitiveSphere1";
import { primitiveSphere2 } from "./test/cases/primitiveSphere2";
import { primitiveSphere3 } from "./test/cases/primitiveSphere3";
import { primitiveSphere4 } from "./test/cases/primitiveSphere4";
import { primitiveSphere5 } from "./test/cases/primitiveSphere5";
import { primitiveMesh1 } from "./test/cases/primitiveMesh1";
import { primitiveMesh2 } from "./test/cases/primitiveMesh2";
import { primitiveMesh3 } from "./test/cases/primitiveMesh3";
import { primitiveMesh4 } from "./test/cases/primitiveMesh4";
import { primitiveMesh5 } from "./test/cases/primitiveMesh5";
import { primitiveLine1 } from "./test/cases/primitiveLine1";
import { primitiveLine2 } from "./test/cases/primitiveLine2";
import { primitiveLine3 } from "./test/cases/primitiveLine3";
import { primitiveLine4 } from "./test/cases/primitiveLine4";
import { primitiveLine5 } from "./test/cases/primitiveLine5";
import { primitivePoint1 } from "./test/cases/primitivePoint1";
import { primitivePoint2 } from "./test/cases/primitivePoint2";
import { primitivePoint3 } from "./test/cases/primitivePoint3";
import { primitivePoint4 } from "./test/cases/primitivePoint4";
import { primitivePoint5 } from "./test/cases/primitivePoint5";
import { spriteView1 } from "./test/cases/spriteView1";
import { spriteView2 } from "./test/cases/spriteView2";
import { labelCollectionView1 } from "./test/cases/labelCollectionView1";
import { tilesetClipping1 } from "./test/cases/tilesetClipping1";
import { pointCloudTilesetFlyover1 } from "./test/cases/pointCloudTilesetFlyover1";
import { kmlFlyovers } from "./test/cases/kmlFlyovers";
import { objFlyover1 } from "./test/cases/objFlyover1";
import { defaultRendererConfig } from "./test/cases";
import { instancedMeshFlyover1 } from "./test/cases/instancedMeshFlyover1";
import { instancedMeshFlyover2 } from "./test/cases/instancedMeshFlyover2";
import { skandMetadataTest } from "./test/cases/skandMetadataTest";
import { CameraProjection } from "./api";
import GestureControl from "./impl/controls/Gesture";
import { Cartographic } from "./private/math";
export * from "./api";
export { Renderer } from "./impl";
/**
 * This function is not part of the public interface, it exists for the test page to use and serve as an API usage
 * example.
 *
 * @param container
 * @param description
 */
export function main(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        // await tileBudgetChanging1(container, description);
        // await tileBudgetChanging2(container, description);
        const cesiumToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI2NTdjNWI0My0wNzBkLTRjNzItYjJhOC1jY2U4MGYyZjk3MzYiLCJpZCI6MjAwNzAsImlhdCI6MTYxMDUwNTE0NH0.WgpaXHkIEUQh7hnzPgPwhz9edq8AiFKPFDM5eeZQ_LU";
        const googleToken = "AIzaSyBQ7Wj99aTxRqET-22qYWGFcDCWgVDt89A";
        yield tilesetViewer(defaultRendererConfig(container, cesiumToken, googleToken), description, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // const _ = renderer
            //     .getWorld()
            //     .getGlobe()
            //     .setTileLayers(
            //         [
            //             { type: "bing", mapType: "aerial" },
            //             // { type: "cesium", assetId: 1077655 },
            //         ],
            //         [
            //             // {
            //             //     type: "cesium",
            //             //     assetId: 1,
            //             // },
            //             // {
            //             //     type: "cesium",
            //             //     assetId: 1077318,
            //             // },
            //         ],
            //     );
            // renderer.config.tilesetNetworkRequests.maxInFlight = 1;
            // renderer.config.globeNetworkRequests.maxInFlight = 1;
            // renderer.config.useLocalCache = false;
            // renderer.config.debug.geometryTileBoundingVolumes = true;
            // renderer.config.debug.imageryTileBoundingVolumes = true;
            const testPosition = new Cartographic(2.633667667706, -0.60151043, 10);
            const model = yield renderer.getObjectFactory().createTileset({
                type: "cesium",
                assetId: 1335446,
                style: {
                    pointSize: 2,
                },
            });
            console.log(model.attributions);
            // const model = await renderer.getObjectFactory().createTileset({
            //     type: "direct",
            //     url: "https://s3.ap-southeast-2.amazonaws.com/skand.production.sites/62ce61e554f797004d69ef06/Files/Process/63744a5293cfd5004f9d88f2/tileset.json",
            // });
            // Load the google maps tileset
            const googleGlobe = yield renderer.getObjectFactory().createTileset({
                type: "google",
            });
            // renderer.getWorld().addObject(googleGlobe);
            // const model = await renderer.getObjectFactory().createTileset({
            //     type: "direct",
            //     //     url: "https://s3.ap-southeast-2.amazonaws.com/skand.production.sites/5fbedb03bba664004e929dfe/61b98cf11f1100004e59814e/61b98d1f367cd4004d93c11f/Files/Tileset3d/61b99050367cd4004d93c125/tileset.json",
            //     //     url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/UAV_UNT/tileset.json",
            //     url: "https://s3.ap-southeast-2.amazonaws.com/skand.staging-v2.sites/63fea175e196a30050b84e3b/Files/Process/64bf6bb2ff18a3004f22ebd7/tileset.json",
            // });
            // model.applyStyle({
            //     pointStyle: PointCloudStyle.IntensityColoring,
            //     gradientColors: [
            //         { r: 0, g: 0, b: 0 },
            //         { r: 1, g: 1, b: 1 },
            //     ],
            //     intensityColors: [
            //         { r: 0, g: 0, b: 0 },
            //         { r: 1, g: 0, b: 0 },
            //         { r: 0, g: 1, b: 0 },
            //         { r: 0, g: 0, b: 1 },
            //     ],
            // });
            // const model = await renderer.getObjectFactory().createObj({
            //     cacheKey: "custom-obj-key2",
            //     url: "testContent/models/Obj/textured_output.obj",
            // });
            // model.setPositionCartographic(testPosition);
            // model.setRotationCartographic(testPosition);
            // const model = await renderer.getObjectFactory().createObj({
            //     cacheKey: "custom-obj-key",
            //     url: "testContent/models/ObjGeo/7270_LYTTON_72702_72700_72703.obj",
            // });
            // console.log(model);
            // const fontAsset = await renderer.createFontAsset({
            //     url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/fonts/Roboto/Roboto-Black.ttf",
            // });
            // const model = await renderer.getObjectFactory().createKml({
            //     type: "cesium",
            //     assetId: 439018,
            //     labelFont: fontAsset,
            //     cacheKey: "custom-kml-key",
            // });
            // const model = await renderer.getObjectFactory().createKml({
            //     type: 'direct',
            //     url: 'https://assets.ion.cesium.com/439018/doc.kml',
            //     labelFont: fontAsset,
            //     cacheKey: 'custom-kml-direct-key',
            // });
            // const model = await renderer.getObjectFactory().createDxf({
            //     // url: "./testContent/models/dxf/bridge.dxf",
            //     // url: "./testContent/models/dxf/cube.dxf",
            //     // url: "./testContent/models/dxf/diamond.dxf",
            //     // url: "./testContent/models/dxf/A-Shape.dxf",
            //     // url: "./testContent/models/dxf/mario.dxf",
            //     // url: "./testContent/models/dxf/rocket.dxf",
            //     // url: "./testContent/models/dxf/crown.dxf",
            //     // url: "./testContent/models/dxf/circles.dxf",
            //     // url: "./testContent/dxf/Z4120C1.dxf",
            //     // url: "./testContent/models/dxf/deer.dxf",
            //     // url: "./testContent/models/dxf/Ellipse.dxf",
            //     // url: "./testContent/models/dxf/train.dxf",
            //     // url: "./testContent/models/dxf/pyramid.dxf",
            //     // url: "./testContent/models/dxf/sensorem.dxf",
            //     // url: "./testContent/models/dxf/Z4120C1.dxf",
            //     // url: "./testContent/models/dxf/Cheltenham PS SAMS Plan.dxf",
            //     // url: "./testContent/models/dxf/TugJetty.dxf",
            //     // url: "./testContent/models/dxf/dxfDoubleLine.dxf",
            //     // url: "./testContent/models/dxf/2018_DXF/Dore Rd Design_EPSG7855_DTM_v2018.dxf",
            //     // url: "./testContent/dxf/Project 3.dxf",
            //     url: "./testContent/dxf/Office 4-1.dxf",
            //     // url: "./testContent/dxf/Office 4-2.dxf",
            //     // url: "./testContent/dxf/bbq rooster met grilldeelbold.dxf",
            //     // url: "./testContent/dxf/internal - belong test.DXF",
            // });
            console.log(model);
            // let start = new Date().getTime();
            // const model = await renderer.getObjectFactory().createIfc({
            //     // url: "https://s3.ap-southeast-2.amazonaws.com/skand.production.sites/615e56760817be004e5f8d72/Files/63872227d22880004ebef4fb/SLM+-+Vaucluse+House+%26+Wentworth+Mausoleum+-+Issue+-+RevB.ifc",
            //     // url: "https://raw.githubusercontent.com/IFCjs/web-ifc/main/examples/example.ifc",
            //     // url: "testContent/models/Forestry.ifc",
            //     // url: "testContent/models/really-big.ifc",
            //     url: "testContent/models/single.ifc",
            //     // url: "testContent/models/test.ifc",
            //     // url: "testContent/models/Tug Jetty.ifc",
            // });
            // console.log(model);
            // let end = new Date().getTime();
            // console.log(`Time to finish building IFC model... ${Math.round(end - start) / 1000} s`);
            // start = new Date().getTime();
            // const nodes: [number, IfcElement | null][] = [[model.getRootElementId(), null]];
            // let ifcTree: IfcElement | null = null;
            // while (nodes.length > 0) {
            //     const [id, parent] = nodes.pop()!;
            //     const properties = model.getElementProperties(id);
            //     if (properties === null) continue;
            //     // @ts-ignore
            //     properties.childElements = [];
            //     if (ifcTree === null) ifcTree = properties;
            //     for (const child of properties.children) {
            //         nodes.push([child, properties]);
            //     }
            //     // @ts-ignore
            //     if (parent) parent.childElements.push(properties);
            //     // @ts-ignore
            //     delete properties.children;
            // }
            // console.log(ifcTree);
            // end = new Date().getTime();
            // console.log(`Time to finish construction IFC tree... ${Math.round(end - start) / 1000} s`);
            const gestures = new GestureControl(renderer.getCanvas());
            const elementMap = new Map();
            gestures.register("keytap", (gesture) => {
                if (gesture.key === " ") {
                    const current = renderer.getWorld().getCamera().getProjectionMode();
                    if (current === CameraProjection.Orthographic) {
                        renderer.getWorld().getCamera().setProjectionMode(CameraProjection.Perspective);
                    }
                    else {
                        renderer.getWorld().getCamera().setProjectionMode(CameraProjection.Orthographic);
                    }
                }
            });
            gestures.register("tap", (gesture) => {
                console.log(googleGlobe.attributions);
                if (gesture.button === 0) {
                    const pickResult = renderer.pickScreenWorldSpaceSnapping(gesture.position);
                    console.log(Object.assign({}, pickResult));
                }
                if (gesture.button === 2) {
                    let time = new Date().getTime();
                    const pickResult = renderer.raycastScreen(gesture.position);
                    time = new Date().getTime() - time;
                    console.log(pickResult, `${time} ms`);
                }
            });
            gestures.register("hover", (gesture) => {
                renderer.raycastScreen(gesture.position);
            });
            // const elementMap = new Map<number, boolean>();
            // gestures.register("tap", (gesture) => {
            //     if (gesture.button === 2) {
            //         const pickResult = renderer.raycastScreen(gesture.position)[0];
            //         if (pickResult && pickResult.object === model && pickResult.userData !== undefined) {
            //             const elementId = pickResult.userData;
            //             console.log(model.getElementProperties(elementId));
            //             const active = elementMap.get(elementId) ?? false;
            //             elementMap.set(elementId, !active);
            //             if (active) {
            //                 model.resetGroupMaterial([elementId]);
            //             } else {
            //                 model.applyGroupMaterial([elementId], {
            //                     type: "basicAlpha",
            //                     color: { r: 1, g: 0, b: 1 },
            //                     alpha: 0.5,
            //                 });
            //             }
            //         } else {
            //             elementMap.clear();
            //             model.resetMaterials();
            //         }
            //     }
            // });
            // const center = new Vector3();
            // const target = new Vector3();
            // model.getEstimatedCenter(center);
            // Ellipsoid.WGS_84.cartesianForCartographic(testPosition, target);
            // const headingQ = new Quaternion().setFromAxisAngle(MathUtils.Y_AXIS.clone().negate(), 0);
            // const matrix3 = new Matrix3();
            // const up = new Vector3();
            // Ellipsoid.WGS_84.rotationBasisForCartographic(testPosition, matrix3, up);
            // const matrix4 = new Matrix4().setFromMatrix3(matrix3);
            // const basisQuaternion = new Quaternion().setFromRotationMatrix(matrix4);
            // const transform = new Matrix4();
            // transform.premultiply(new Matrix4().makeTranslation(-center.x, -center.y, -center.z));
            // transform.premultiply(new Matrix4().makeRotationFromQuaternion(basisQuaternion.multiply(headingQ)));
            // transform.premultiply(new Matrix4().makeTranslation(target.x, target.y, target.z));
            // const translation = new Vector3();
            // const rotation = new Quaternion();
            // const scale = new Vector3();
            // transform.decompose(translation, rotation, scale);
            // model.setPositionECEF(translation);
            // model.setRotation(rotation);
            return model;
        }), undefined, false);
        yield skandMetadataTest(container, description);
        yield instancedMeshFlyover1(container, description);
        yield instancedMeshFlyover2(container, description);
        yield objFlyover1(container, description);
        yield kmlFlyovers(container, description);
        yield pointCloudTilesetFlyover1(container, description);
        yield tilesetClipping1(container, description);
        yield labelCollectionView1(container, description);
        yield spriteView1(container, description);
        yield spriteView2(container, description);
        yield primitivePoint1(container, description);
        yield primitivePoint2(container, description);
        yield primitivePoint3(container, description);
        yield primitivePoint4(container, description);
        yield primitivePoint5(container, description);
        yield primitiveLine1(container, description);
        yield primitiveLine2(container, description);
        yield primitiveLine3(container, description);
        yield primitiveLine4(container, description);
        yield primitiveLine5(container, description);
        yield primitiveMesh1(container, description);
        yield primitiveMesh2(container, description);
        yield primitiveMesh3(container, description);
        yield primitiveMesh4(container, description);
        yield primitiveMesh5(container, description);
        yield primitiveBox1(container, description);
        yield primitiveBox2(container, description);
        yield primitiveBox3(container, description);
        yield primitiveBox4(container, description);
        yield primitiveBox5(container, description);
        yield primitiveSphere1(container, description);
        yield primitiveSphere2(container, description);
        yield primitiveSphere3(container, description);
        yield primitiveSphere4(container, description);
        yield primitiveSphere5(container, description);
        yield panoramaView1(container, description);
        yield panoramaView2(container, description);
        yield panoramaView3(container, description);
        yield panoramaView4(container, description);
        yield layeredImageryFlyover1(container, description);
        yield layeredImageryFlyover2(container, description);
        yield bingImageryFlyover1(container, description);
        yield bingImageryFlyover2(container, description);
        yield bingImageryFlyover3(container, description);
        yield osmImageryFlyover1(container, description);
        yield cesiumImageryFlyover1(container, description);
        yield instancedMeshTilesetFlyover1(container, description);
        yield movingGradientColor1(container, description);
        yield movingIntensityColor1(container, description);
        yield movingClassificationColor1(container, description);
        yield meshTilesetFlyover1(container, description);
        yield meshTilesetFlyover2(container, description);
        yield meshTilesetFlyover3(container, description);
        yield meshTilesetFlyover4(container, description);
    });
}
